import { createContext, useContext, useState, useEffect } from 'react';
import { fetchLocationsPageData } from './pageDataService';

const LocationsDataContext = createContext(null);

export const LocationsDataProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    try {
      const cached = localStorage.getItem('bento_locations_data');
      return cached ? JSON.parse(cached) : null;
    } catch (e) {
      return null;
    }
  });
  
  const [isLoading, setIsLoading] = useState(!data);

  useEffect(() => {
    let isMounted = true;

    fetchLocationsPageData().then((result) => {
      if (isMounted && result) {
        setData(result);
        setIsLoading(false);
        try {
          localStorage.setItem('bento_locations_data', JSON.stringify(result));
        } catch (e) {
          console.error("Failed to cache locations data", e);
        }
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <LocationsDataContext.Provider value={{ data, isLoading }}>
      {children}
    </LocationsDataContext.Provider>
  );
};

export const useLocationsData = () => {
  const context = useContext(LocationsDataContext);
  if (!context) {
    return { data: null, isLoading: true };
  }
  return context;
};
